import * as React from 'react'
require('../base.module.scss')
import omit from '../Common/omit'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import * as st from './Link.module.scss'

export interface LinkProps extends BaseComponentProps {
    id?: string
    name?: string
    text?: React.ReactNode
    href?: string
    ariaLabel?: string
    rel?: string
    title?: string
    target?: string
    isHighlighted?: boolean
    onClick?: (e: React.MouseEvent<HTMLElement> | React.MouseEvent<HTMLAnchorElement>) => void
}

export const Link: React.ComponentType<LinkProps> = (props) => {
    const { text, ariaLabel, children } = props
    const className = extractClassNamesFromProps(props, st.link)

    return (
        <a {...omit(props, ['isHighlighted', 'text', 'ariaLabel'])} className={className} aria-label={ariaLabel}>
            {text}
            {children}
        </a>
    )
}

// Add displayName to preserve the component name on snapshot testing
Link.displayName = 'Link'
